import { supabase } from '../lib/supabase';

// Demo accounts (the seeded @constructionco.uk org plus the configured demo
// admin) must never silently fake-succeed on writes. Mutations short-circuit
// to this error so each caller's existing error path surfaces it inline, while
// the retained `demo-mode-action` dispatch still drives the global
// DemoModeToast. Single source of truth for the precedent established by
// DNllfNne PR 3 (RczeIfwZ extends it across the remaining services).
export const DEMO_ERROR_MESSAGE = 'Demo mode: changes are not saved';

// Sync predicate for call sites that already have the user's email loaded.
export const isDemoUser = (email) => {
  const demoAdminEmail = import.meta.env?.VITE_DEMO_ADMIN_EMAIL;
  return Boolean((demoAdminEmail && email === demoAdminEmail) || email?.endsWith('@constructionco.uk'));
};

// Async convenience for call sites that don't otherwise load the user (e.g.
// status/delete mutations) — fetches the session and applies isDemoUser.
export const isDemoCurrentUser = async () => {
  try {
    const { data: { user } } = await supabase?.auth?.getUser();
    return isDemoUser(user?.email);
  } catch {
    return false;
  }
};
